var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMaterial)?_c('i',{ref:"icon",class:[
        'icon-material',
        _vm.size ? 'icon-material--' + _vm.size : '',
        _vm.clickable && !_vm.disabled ? 'icon-material--clickable' : '',
        _vm.isOff ? 'is-off' : '',
        _vm.isDisabled || _vm.disabled ? 'is-disabled' : '',
        _vm.typeClass,
        _vm.hoverTypeClass,
        _vm.positionClass,
        _vm.className ? _vm.className : '',
    ],attrs:{"title":_vm.title},on:{"click":function($event){_vm.clickable && !_vm.isDisabled ? _vm.handleClick($event) : null}}},[_c('span',{staticClass:"icon-material_icon"},[_vm._v(_vm._s(_vm.icon))])]):_c('svg',{ref:"icon",class:[
        'icon',
        _vm.typeClass,
        _vm.size ? 'icon--' + _vm.size : '',
        _vm.clickable && !_vm.disabled ? 'icon--clickable' : '',
        _vm.isOff ? 'is-off' : '',
        _vm.isDisabled || _vm.disabled ? 'is-disabled' : '',
        _vm.positionClass,
        _vm.className ? _vm.className : '',
    ],attrs:{"title":_vm.title},on:{"click":function($event){_vm.clickable && !_vm.isDisabled ? _vm.handleClick($event) : null}}},[_c('use',{attrs:{"xlink:href":`/Scripts/dist/sprite.svg#${this.icon}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }